import { definitions } from 'api/generated/photo'
import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'

/**
 * Нельзя открыть из рейтинга фотовьювер,
 * Иначе будет запрос по id пользователя и будут другие фото
 * Поэтому мы конвертим в то что понимает фотовьювер и передаем в него
 * Далее просто открываем без запроса.
 */
export const convertPhotos = (
  photos: GQLPhotoItemFragment[],
  profileId: number
): definitions['OmniAlbumPhoto'][] => {
  const _photos = [
    ...photos.map<definitions['OmniAlbumPhoto']>((photo) => ({
      photoId: Number(photo.photoId),
      urls: {
        id: Number(photo.photoId),
        aid: profileId,
        square: photo.urls.square,
        medium: photo.urls.square,
        small: photo.urls.square,
        smallWithFace: photo.urls.square,
        squareLarge: photo.urls.squareLarge,
        squareSmall: photo.urls.squareSmall,
        huge: photo.urls.huge,
        xHuge: photo.urls.huge,
      },
      portrait: photo.portrait,
      pending: false,
      moderationStatus: 'approved',
      verified: photo.verified,
      likes: photo.likes,
      liked: photo.liked,
      voteable: photo.voteable,
      voted: photo.voted,
      main: photo.main,
      faceCoordinates: {
        xHuge: {
          x: photo.faceCenter?.xHuge?.x || 0,
          y: photo.faceCenter?.xHuge?.y || 0,
        },
        huge: {
          x: photo.faceCenter?.huge?.x || 0,
          y: photo.faceCenter?.huge?.y || 0,
        },
      },
      width: photo.width,
      height: photo.height,
      commentInfo: {
        contentId: '',
        gift: false,
        sticker: false,
        text: false,
      },
      commentsCount: false,
      sizes: {
        huge: {
          width: photo.width,
          height: photo.height,
        },
        square: {
          width: photo.width,
          height: photo.height,
        },
        squareLarge: {
          width: photo.width,
          height: photo.height,
        },
      },
    })),
  ]

  return _photos
}
